module.exports = __webpack_public_path__ + "static/media/footer-background.594ac9c7.jpg";